import { getOrganizationFooterHtml } from "@components/Organization"
import Organization from "./Organization"

export default Organization
export { getOrganizationFooterHtml }
